import { useTheme } from '@mui/material';
import { Checkbox, type CheckboxProps } from '@mui/material';

interface IndeterminateCheckboxProps extends Omit<CheckboxProps, 'indeterminate'> {
  indeterminate?: boolean;
}

function IndeterminateCheckbox({ indeterminate, checked, ...rest }: IndeterminateCheckboxProps) {
  const theme = useTheme();
  return (
    <Checkbox
      checked={checked}
      indeterminate={indeterminate && !checked}
      size='small'
      sx={{
        padding: 0,
        color: theme.hhglobal.neutral.gray700,
        '&.Mui-checked': {
          color: theme.hhglobal.neutral.gray700,
        },
        '&.MuiCheckbox-indeterminate': {
          color: theme.hhglobal.neutral.gray700,
        },
      }}
      {...rest}
    />
  );
}

export default IndeterminateCheckbox;
